import $ from 'jquery'
import slick from 'slick-carousel'
import LazyLoad from "vanilla-lazyload"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)
import ModalVideo from 'modal-video'
import 'jquery-modal'
import imageMapResize from 'image-map-resizer'
import lightbox from 'lightbox2'

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'basic', slidesNumber = 1) => {
  const $el = $(el);
  const opts = {
    basic: {
      dots: true,
      autoplay: true,
      autoplaySpeed: 6000,
      infinite: true,
      fade: true,
    },
    customers: {
      autoplay: true,
      arrows: false,
      variableWidth: true,
      centermode: true,
      infinite: true,
      swipeToSlide: true,
      autoplaySpeed: 2000,
    },
    productMachinery: {
      dots: true,
      arrows: false,
      infinite: false,
    }
  }

  $el.slick(opts[type])
}

/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    data_src: "src",
  })
}

/* SMOOTH SCROLL
  ----------------------------- */
export const smoothScroll = () => {
  $('a[href*="#"]:not([href="#"]):not([href="#top"]):not([target="_blank"]):not([href*="#modal"])').click(function(e) {
    const target = $(this.hash)
    if (target.length > 1) e.preventDefault()
    $('html, body').animate({ scrollTop: target.offset().top-100 }, 1000)
  })

  $("a[href='#top']").click(function(e) {
    e.preventDefault()
    $('html, body').animate({ scrollTop: 0 }, 800)
  })
}

/* HEADER ANIMATION
  ----------------------------- */
export const menuOverlay = () => {
  const toggle = $('.header__toggle')
  const bar = $('.header__toggle .bar')
  const overlay = $('.header--offcanvas, .header__inner, .content-area, body')
  const link = $('.header--offcanvas a:not([href="#"])');
  const header = $('.header--main');

  toggle.on('click', function () {
    overlay.toggleClass('open')
    bar.toggleClass('animate')
    toggle.toggleClass('open')
  })

  link.on('click', function () {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  })

  // window.onresize = () => {
  //   overlay.removeClass('open')
  //   bar.removeClass('animate')
  //   toggle.removeClass('open')
  // }

  $(document).scrollTop() > 200 ?
    header.addClass('sticky') :
    header.removeClass('sticky')

  $(window).scroll(function(e) {
    $(document).scrollTop() > 200 ?
      header.addClass('sticky') :
      header.removeClass('sticky')

    this.oldScroll > this.scrollY ?
      header.addClass('sticky-show').removeClass('sticky-hide') :
      header.addClass('sticky-hide').removeClass('sticky-show')
    this.oldScroll = this.scrollY
  })
  
  $('.menu-item-has-children > a').on('click', function (e) {
    e.preventDefault()
    $(this).parent().toggleClass('open')
    $(this).next('.sub-menu').slideToggle(300)
  })
}

/* SETUP MODALVIDEO
  ----------------------------- */
export const setupModalVideo = () => {
  if ($('.js-modal-btn').length > 0 || $('.js-modal-btn-vimeo').length > 0) {
    new ModalVideo('.js-modal-btn')
    new ModalVideo('.js-modal-btn-vimeo', { channel: 'vimeo' })
  }
}

/* SETUP ACCORDION
  ----------------------------- */
export const setupAccordions = () => {
  if ($('.accordion').length === 0) return
  $('.accordion-title').on('click', function () {
    $(this).parent().toggleClass('open')
    $(this).next('.accordion-content').slideToggle()
    $(this).prev('.accordion-content').slideToggle()
  })
}

/* PRODUCT ARROW COLOR
  ----------------------------- */
export const productArrowColor = () => {
  $('.product__accordion-arrow').each(function () {
    const color = $(this).data('color');
    $(this).find('svg path').css('fill', color);
  })
}

/* SETUP TAB PRODUCTS
  ----------------------------- */
export const setupTabProducts = () => {
  $('.section--home-solutions .section__tab-item').on('click', function () {
    const tab = $(this).data('tab')
    $('.section--home-solutions .section__tab-item').removeClass('active color--white bg--primary').addClass('color--primary bg--primary-light')
    $(this).removeClass('color--primary bg--primary-light').addClass('active color--white bg--primary')

    $('.section--home-solutions .section__solution').removeClass('active')
    $(`.section--home-solutions .section__solution[data-tab="${tab}"]`).addClass('active')

    // Reset image map resize
    imageMapResize()
  })
}

/* ANIMATE NUMBERS
  ----------------------------- */
export const animateNumbers = () => {
  if ($(".section--home-sustainability-numbers").length === 0) return

  ScrollTrigger.create({
    trigger: ".section--home-sustainability-numbers",
    start: "top 45%",
    onEnter: () => {
      $(".section__number strong").each(function () {
        gsap.fromTo(this, { innerHTML: 0 }, { innerHTML: parseInt($(this).attr("data-number")), duration: 3, ease: "power1.out", snap: { innerHTML: 1 } })
      })
    },
    once: true
  })
}

/* SETUP MAP IMAGES
  ----------------------------- */
export const setupMapImages = () => {
  if ($('map').length === 0) return

  // Highlight on area hover
  $('map area').on('mouseover mouseout', function(e) {
    const href = $(this).attr('href')
    const targets = $(`[data-product="${href}"]`)
    targets.toggleClass('active hovered', e.type === 'mouseover')
  })

  // Trigger click on area
  $('map area').on('click', function (e) {
    e.preventDefault()
    const href = $(this).attr('href')
    const link = $(`[data-product="${href}"]`).filter('a').first()
    if (link.length) link[0].click()
  })

  // Highlight on product hover
  $('a[data-product]').on('mouseover mouseout', function (e) {
    const product = $(this).data('product')
    $(`div[data-product="${product}"]`).toggleClass('active', e.type === 'mouseover')
  })
}